import React from 'react';

import { Select } from '@aline/common';
import { Typography } from '@mui/material';
import { CircleIconFilled } from 'src/components/icons/CircleIconFilled';
import type { Apollo } from 'src/gql/generated';
import { getWorkflowStateColor, getWorkflowStateDisplayString } from 'src/workflow';
import { makeStyles } from 'tss-react/mui';

const useStyles = makeStyles()(theme => ({
  container: {
    alignItems: 'center',
    display: 'flex',
  },
  statusIcon: {
    marginRight: theme.spacing(1),
  },
  statusText: {
    fontWeight: 600,
  },
}));

interface WorkflowStageProps {
  workflow: Pick<Apollo.Workflow, 'state' | '__typename'>;
}

export function WorkflowStage({ workflow }: WorkflowStageProps): JSX.Element | null {
  const { classes } = useStyles();

  return (
    <div className={classes.container}>
      <CircleIconFilled
        className={classes.statusIcon}
        fill={getWorkflowStateColor(workflow.state)}
      />
      <Typography
        noWrap
        className={classes.statusText}
        data-cy={Select.workflow.detail.toolbar.signatureStatusText}
      >
        {getWorkflowStateDisplayString(workflow.state).toUpperCase()}
      </Typography>
    </div>
  );
}
